import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { MatDrawerMode } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Subject, Subscription, takeUntil } from 'rxjs';

import { MerchantSelectors } from '@merchant/store/merchant.slice';
import { ProductSearchActions } from '@search/store/search.slice';
import { hasBanner } from '@shared/interfaces/banner.interface';

@Component({
  selector: 'app-search-layout',
  templateUrl: './search-layout.component.html',
  styleUrls: ['./search-layout.component.scss'],
})
export class SearchLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() contentOnCard = true;
  sidenavMode: MatDrawerMode = 'side';

  private subs = new Subscription();

  hasBanner = false;

  private _isSidenavOpen: boolean = this.sidenavMode === 'side';
  set isSidenavOpen(value: boolean) {
    this._isSidenavOpen = value;

    if (value) {
      // const sideNav = document.getElementById('search-sidenav');
      // const closeBtn = document.getElementById('search-container-close-btn');
      // if (sideNav && closeBtn) {
      //   const closeBtnClone: HTMLButtonElement = (
      //     closeBtn as HTMLButtonElement
      //   ).cloneNode(true) as HTMLButtonElement;
      //   closeBtnClone.classList.add('outer-close-btn');
      //   closeBtnClone.onclick = () => {
      //     this._isSidenavOpen = false;
      //   };
      //   this.renderer.appendChild(sideNav, closeBtnClone);
      // }
    }
    this.store.dispatch(
      ProductSearchActions.updateIsSidenavOpen.trigger({ isSidenavOpen: value })
    );
  }
  get isSidenavOpen() {
    return this._isSidenavOpen;
  }

  siteSelected$ = this.store.select(MerchantSelectors.selectIsSiteSelected);

  showPanel = true;
  private destroyed = new Subject<void>();
  constructor(
    private breakpointObserver: BreakpointObserver,
    private store: Store,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.setSidenavMode();
    breakpointObserver
      .observe([Breakpoints.Small])
      .pipe(takeUntil(this.destroyed))
      .subscribe(() => {
        this.setSidenavMode();
      });
  }

  ngOnInit(): void {
    this.hasBanner = hasBanner(this.route);
    this.subs.add(
      this.router.events.subscribe((e) => {
        if (e instanceof NavigationEnd) {
          this.hasBanner = hasBanner(this.route);
        }
      })
    );
  }

  ngAfterViewInit(): void {
    const sideNav = document.getElementById('search-sidenav');

    const closeBtn = document.getElementById('search-container-close-btn');
    if (sideNav && closeBtn) {
      const closeBtnClone: HTMLButtonElement = (
        closeBtn as HTMLButtonElement
      ).cloneNode(true) as HTMLButtonElement;
      closeBtnClone.classList.add('outer-close-btn');
      closeBtnClone.onclick = () => {
        this._isSidenavOpen = false;
      };
      this.renderer.appendChild(sideNav, closeBtnClone);
    }
  }

  setSidenavMode() {
    this.sidenavMode =
      this.breakpointObserver.isMatched('(max-width: 892px)') && this.showPanel
        ? 'over'
        : 'side';
    this.isSidenavOpen =
      !this.breakpointObserver.isMatched('(max-width: 892px)') &&
      this.showPanel;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.destroyed.next();
    this.destroyed.complete();
  }
}
